<template lang="pug">
#store.equipment-tech-map
  .spinner-container.form-spinner(v-if="loading")
    q-spinner(color="primary", size="3em")

  .tech-map-card(v-if="!loading")
    .techmap-info-blocks
      .spinner-container.form-spinner(v-if="loadingBlocks")
        q-spinner(color="primary", size="3em")

      .specification-block(v-if="!loadingBlocks")
        history(
          v-if="tableData",
          :parentData="{ data: tableData }",
          :data="tableData",
          :columns="tableColumns",
          :hasNextPage="hasNextPage",
          :loadingMore="loadingMore",
          :loadingTable="loadingTable",
          @loadMore="loadMore",
          @reloadData="reloadWithSort"
        )
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import history from "../../history/history";
import backend from "@/api";
import { Notify } from "quasar";
import { notifies } from "@/services/useLocales";
import { handleError } from "@/services/handleErrors";

const props = defineProps({
  parentData: { type: Object, default: () => {} },
});

const { rowId } = props.parentData;
const tableData = ref([]);
const tableColumns = ref([]);
const loading = ref(true);
const loadingBlocks = ref(true);
const page = ref(1);
const currentSort = ref("id");
const descending = ref(true);
const query = ref("");
const hasNextPage = ref(false);
const loadingMore = ref(false);
const loadingTable = ref(false);

const fileIcon = computed(() => require(`../../../../../assets/icons/header/file.svg`));

const reloadWithSort = async params => {
  page.value = 1;
  tableData.value = [];

  if (params.sort) {
    currentSort.value = params.sort;
    descending.value = params.sort_direction === "down";
  }

  if (params.query) {
    query.value = params.query;
  } else {
    query.value = "";
  }

  loadingTable.value = true;
  await loadData(params);
};

const loadData = async (params = {}) => {
  try {
    const json = {
      table: {
        rowsPerPage: 20,
        page: page.value,
        sortBy: currentSort.value,
        descending: descending.value,
      },
    };

    const { data } = await backend.index(`/api/v3/stores/${rowId}/consumptions_history?json=${JSON.stringify(json)}`);

    if (page.value === 1) {
      tableColumns.value = data.columns;
    }

    tableData.value = tableData.value.concat(data.data);
    hasNextPage.value = checkHasNextPage(data);
  } catch (error) {
    await handleError(error);
  } finally {
    loading.value = false;
    loadingBlocks.value = false;
    loadingMore.value = false;
    loadingTable.value = false;
  }
};

const checkHasNextPage = data => {
  const count = data.count;
  const perPage = data.pagination.rowsPerPage;
  return count - perPage * page.value > 0;
};

const loadMore = async () => {
  page.value++;
  loadingMore.value = true;
  await loadData();
};

onMounted(async () => {
  await loadData();
});
</script>

<style lang="scss">
#store .techmap-info-blocks,
#store .equipment-tech-map,
#store .tabs-block {
  min-height: 0;
}

#store {
  .specification-title span {
    font-size: 20px !important;
    color: var(--tab-text-color) !important;
  }
  &.equipment-tech-map .tech-map-card .specification-block {
    margin-top: 58px;
  }
  .equipment-tech-map {
    border-bottom: var(--tabs-block-td-border) !important;
    border-right: var(--tabs-block-td-border) !important;
    position: relative;
    .tech-map-card {
      .tabs-block {
        max-height: calc(66vh - 100px);
        margin-top: 0;
        td {
          padding: 10px;
        }
        thead {
          position: absolute;
          display: table;
          table-layout: fixed;
          top: -40px;
        }
        tr {
          display: table;
          table-layout: fixed;
          width: 100%;
        }
      }
    }
  }
}

.materials-import-button {
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 10px;
  border-radius: 8px;
  background-color: #5b7aff;
  color: #fff;
}

#components-table.stores td {
  color: var(--tab-text-color);
}
</style>
